import { nameof } from 'ts-simple-nameof';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { OrdersGridItemData } from './OrdersScreen';
import React from 'react';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import Button, { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDrawerDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Drawer/Drawer';
import { iToolbarDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Toolbar/Toolbar';
import { StateOrderSimpleTextDisplayOptions } from '../../components/state-order-simple-text/StateOrderSimpleText';

export const ordersScreenId = 'ordersGrid';

// Dodac
{
    /*<Paging defaultPageSize={25}/>*/
}
{
    /*<Pager*/
}
{
    /*    visible={true}*/
}
{
    /*    showPageSizeSelector={true}*/
}
{
    /*    allowedPageSizes={[10, 20, 25, 40]}*/
}
{
    /*    showInfo={true}/>*/
}

// Filtry
// +
//     Nr
//     ID transportu
//     Id WMS
//     Data awizacji
//     Data Stworzenie
//     Status
//     Przekazanie do realizacji
// -
//     Oddział zlecający
//     Punkty rozładunku
//     Punkty załadunku
//     Wypełnienie auta
//     Przewożnik

export const ordersGridOptions: iDataGridDisplayOptions = {
    id: ordersScreenId,
    selection: {
        mode: 'single',
    },
    columnAutoWidth: false,
    showBorders: true,
    columnHidingEnabled: false,
    allowColumnReordering: true,
    allowColumnResizing: true,
    filterRow: {
        visible: true,
    },
    headerFilter: {
        allowSearch: true,
    },
    columnChooser: {
        enabled: false,
    },
    paging: {
        pageSize: 10,
    },
    editing: {
        allowDeleting: false,
        useIcons: false,
    },
    columns: [
        {
            dataField: nameof<OrdersGridItemData>((c) => c.id),
            caption: 't~OrdersScreen:column.id',
            cellTemplate: 'RowIndexColumn',
            allowFiltering: false,
            alignment: 'center',
            width: '50px',
        },
        {
            dataField: nameof<OrdersGridItemData>((c) => c.tmsExternalId),
            caption: 't~OrdersScreen:column.tmsExternalId',
            alignment: 'center',
            width: '100px',
        },
        {
            cellTemplate: 'WmsExternalIdsColumn',
            caption: 't~OrdersScreen:column.wmsExternalId',
            dataField: nameof<OrdersGridItemData>((c) => c.wmsExternalId),
            alignment: 'center',
        },
        {
            dataField: nameof<OrdersGridItemData>(
                (c) => c.forwardSteps!.firstUnload!.plannedStartDate
            ),
            caption: 't~OrdersScreen:column.plannedStartDate',
            dataType: 'date',
            format: 'shortDateShortTime',
            selectedFilterOperation: 'between',
            sortOrder: 'desc',
            alignment: 'center',
        },
        {
            dataField: nameof<OrdersGridItemData>((c) => c.createdDate),
            caption: 't~OrdersScreen:column.createdDate',
            dataType: 'date',
            selectedFilterOperation: 'between',
            format: 'shortDateShortTime',
            alignment: 'center',
        },
        {
            dataField: nameof<OrdersGridItemData>((c) => c!.editedBy),
            caption: 't~OrdersScreen:column.editedBy',
            cellTemplate: 'EditedBySimpleTextColumn',
            alignment: 'center',
            allowFiltering: false,
            allowReordering: false,
            allowHeaderFiltering: false,
            allowSorting: false,
            allowGrouping: false,
        },
        {
            caption: 't~OrdersScreen:column.state',
            cellTemplate: 'StateOrderColumn',
            calculateSortValue: nameof<OrdersGridItemData>((c) => c!.state),
            lookup: {
                displayExpr: 'name',
                valueExpr: 'key',
                dataSource: [
                    {
                        name: 'Szkic',
                        key: 'Draft',
                    },
                    {
                        name: 'Przetwarzanie',
                        key: 'SendingInProgress',
                    },
                    {
                        name: 'Wysłane do WMSa',
                        key: 'SentToWMS',
                    },
                    {
                        name: 'Wysłane do WMSa i TMSa',
                        key: 'SentToWMSAndTMS',
                    },
                    {
                        name: 'W trakcie',
                        key: 'InProgress',
                    },
                    {
                        name: 'Zrealizowano',
                        key: 'Completed',
                    },
                    {
                        name: 'Anulowane przez TMS',
                        key: 'CancelledByTMS',
                    },
                    {
                        name: 'Wystąpił błąd',
                        key: 'Error',
                    },
                ],
            },
            dataField: nameof<OrdersGridItemData>((c) => c!.state),
            allowSorting: true,
            alignment: 'center',
        },
        {
            dataField: nameof<OrdersGridItemData>((c) => c!.draftCloseDeadline),
            caption: 't~OrdersScreen:column.draftCloseDeadline',
            dataType: 'date',
            selectedFilterOperation: 'between',
            cellTemplate: 'DraftClosedDeadlineColumn',
            alignment: 'center',
        },
        {
            dataField: nameof<OrdersGridItemData>((c) => c!.forwardSteps!.items),
            caption: 't~OrdersScreen:column.Unload',
            cellTemplate: 'ForwardStepsLocationsColumn',
            alignment: 'center',
            allowFiltering: false,
            allowReordering: false,
            allowHeaderFiltering: false,
            allowSorting: false,
            allowGrouping: false,
        },
        {
            dataField: nameof<OrdersGridItemData>((c) => c!.returnSteps!.items),
            caption: 't~OrdersScreen:column.Load',
            cellTemplate: 'ReturnStepsLocationsColumn',
            alignment: 'center',
            allowFiltering: false,
            allowReordering: false,
            allowHeaderFiltering: false,
            allowSorting: false,
            allowGrouping: false,
        },
        {
            caption: 't~OrdersScreen:column.truckFilling',
            cellTemplate: 'TruckFillingColumn',
            alignment: 'center',
            allowFiltering: false,
            allowReordering: false,
            allowHeaderFiltering: false,
            allowSorting: false,
            allowGrouping: false,
        },
        {
            dataField: nameof<OrdersGridItemData>((c) => c!.transportOperator),
            caption: 't~OrdersScreen:column.transportOperator',
            cellTemplate: 'TransportOperatorSimpleTextColumn',
            alignment: 'center',
            allowFiltering: false,
            allowReordering: false,
            allowHeaderFiltering: false,
            allowSorting: false,
            allowGrouping: false,
        },
    ],
};
propsStore.insert(ordersGridOptions);

export const orderScreenButtonId = 'OrdersScreenButton';

export const orderScreenAddNewOrderOptions: iButtonDisplayOptions = {
    id: orderScreenButtonId,
    //
    text: 't~OrdersScreen:addNewOrder',
    type: 'success',
    stylingMode: 'contained',
    width: '250px',

    //
};
propsStore.insert(orderScreenAddNewOrderOptions);

export const orderScreenOrderInfoDrawerId = 'orderScreenOrderInfoDrawerId';
export const orderScreenOrderInfoDrawerOptions: iDrawerDisplayOptions = {
    id: orderScreenOrderInfoDrawerId,
    openedStateMode: 'overlap',
    position: 'right',
    closeOnOutsideClick: true,
};

propsStore.insert(orderScreenOrderInfoDrawerOptions);

export const orderScreenOrderInfoDrawerToolBarId = 'orderScreenOrderInfoDrawerId';
export const orderScreenOrderInfoDrawerToolBarOptions: iToolbarDisplayOptions = {
    id: orderScreenOrderInfoDrawerToolBarId,
};
propsStore.insert(orderScreenOrderInfoDrawerToolBarOptions);

export const ordersGridColumnStateId = 'ordersGrid.column.state';
export const ordersGridColumnStateOptions: StateOrderSimpleTextDisplayOptions = {
    id: ordersGridColumnStateId,
    showErrorInfo: true,
    statusAsTag: false,
    orderErrorInfoDisplayOptions: {
        onEditClick: 'cb~orderErrorOnEditClick' as any,
    },
};
propsStore.insert(ordersGridColumnStateOptions);
